import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import {
    MainContainer,
    MainEntityListItemText,
    MasterDetailsAsideItem,
} from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { LoanProduct } from 'src/generated-api-client';
import { ProductStatus } from 'src/pages/ProductsPage/ProductStatus';

type ProductListItemProps = { product: LoanProduct };

export const ProductListItem = observer(({ product }: ProductListItemProps) => {
    return (
        <MasterDetailsAsideItem
            to={EntityLinks.products.itemDetails(product.id)}
        >
            <MainContainer>
                <Tooltip title={product.code}>
                    <EllipsisContainer>
                        <MainEntityListItemText className="strong-text">
                            {product.code}
                        </MainEntityListItemText>
                    </EllipsisContainer>
                </Tooltip>
                <ProductStatus item={product} />
            </MainContainer>
        </MasterDetailsAsideItem>
    );
});
